import React from "react";
import { useTheme } from "@chakra-ui/react";
import { keyframes } from "@chakra-ui/system";
import { wax } from "../../core";
import { Box } from "../Box";
const edgeState = {
    transform: "rotate(0deg)",
    opacity: 1,
};
const spin = keyframes({
    "0%": edgeState,
    "50%": {
        transform: "rotate(90deg)",
        opacity: 0.85,
    },
    "100%": edgeState,
});
/**
 * Loaders provide a visual cue that an action is processing awaiting a course of change or a result. In a shape of a spinning noom logo.
 */
export function ClientLoader({ size = "md", color, speed = "2.5s", isAnimated = true, colorScheme = "primary", }) {
    const theme = useTheme();
    const themeStyle = theme.components.ClientLoader.sizes[size];
    const svgColor = !color && colorScheme ? `${colorScheme}.500` : color;
    return (React.createElement(Box, { position: "relative", h: themeStyle.h, w: themeStyle.w },
        React.createElement(Box, { h: themeStyle.h, w: themeStyle.w, position: "absolute", animation: isAnimated
                ? `${spin} ${speed} cubic-bezier(0.5, 0, 0.5, 1) infinite`
                : undefined },
            React.createElement(wax.svg, { height: themeStyle.h, width: themeStyle.w, fill: svgColor, viewBox: "0 0 44 43", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("path", { d: "M31.656 12.064C25.32 5.874 22.005.008 22 0c-.005.009-3.322 5.874-9.656 12.064C6.011 18.253.008 21.495 0 21.5c.008.005 6.01 3.246 12.344 9.436C18.68 37.126 21.995 42.992 22 43c.005-.008 3.322-5.874 9.656-12.064C37.989 24.746 43.992 21.505 44 21.5c-.008-.005-6.01-3.246-12.344-9.436z" })))));
}
ClientLoader.displayName = "ClientLoader";
export default ClientLoader;
//# sourceMappingURL=ClientLoader.js.map